import { IS_SSR } from 'constants/isssr';
import * as React from 'react';
export const setFlagAfterSSRRender = (flag) => {
    const [value, setValue] = React.useState(false);
    React.useEffect(() => {
        setValue(!IS_SSR && flag);
    }, [flag]);
    return value;
};
